module.exports = __webpack_public_path__ + "img/icon-warning-wind-orange.d9b7fe3b.svg";